import { LoadingContainer, Model } from 'peach/components'
import { useParams } from 'peach/router'

import { Page } from 'core/components'
import { useBootstrap } from 'core/types'

const CompanyBootstrap = () => {
  const { companyId } = useParams<{ companyId?: string }>()

  const { data: borrowerBootstrap, isLoading: isLoadingBorrowerBootstrap } =
    useBootstrap({
      query: { companyId, appDomainType: 'borrower' },
    })

  const { data: agentBootstrap, isLoading: isLoadingAgentBootstrap } =
    useBootstrap({
      query: { companyId, appDomainType: 'agent' },
    })

  const { data: adminBootstrap, isLoading: isLoadingAdminBootstrap } =
    useBootstrap({
      query: { companyId, appDomainType: 'admin' },
    })

  return (
    <LoadingContainer
      loading={
        isLoadingBorrowerBootstrap ||
        isLoadingAgentBootstrap ||
        isLoadingAdminBootstrap
      }
    >
      <Page variant='full'>
        <Model.Item json={borrowerBootstrap} title='Borrower' />
        <Model.Item json={agentBootstrap} title='Agent' />
        <Model.Item json={adminBootstrap} title='Admin' />
      </Page>
    </LoadingContainer>
  )
}

export default CompanyBootstrap
